import ActionType from "../../isp._comun/reductores/ActionType";
export default class ActionTypePrincipal extends ActionType {}
